export enum AuthEventChannel {
  AUTH_EVENTS = "auth-events",
}

export enum AuthEventType {
  LOGOUT_REQUIRED = "LOGOUT_REQUIRED",
}
